import { useTranslation } from "react-i18next";
import "./Projects.css";

// Stable id list — names + content live in i18n. Adding a product means
// adding its key here AND under projects.products.<key> in every locale.
const FLAGSHIPS = ["siplanp", "ntnutri"];
const PRODUCTS = ["nierbusyness", "yorwha", "magnum"];

export default function Projects() {
  const { t } = useTranslation();
  return (
    <section id="produtos" className="projects section">
      <div className="container">
        <header className="projects__header">
          <span className="projects__eyebrow">{t("projects.eyebrow")}</span>
          <h2 className="projects__title">{t("projects.title")}</h2>
          <p className="projects__lead">{t("projects.lead")}</p>
        </header>

        <div className="projects__grid projects__grid--flagship">
          {FLAGSHIPS.map((key) => {
            const features = t(`projects.flagships.${key}.features`, { returnObjects: true });
            return (
              <article key={key} className="flagship-card">
                <span className="flagship-card__tag">{t(`projects.flagships.${key}.tag`)}</span>
                <h3 className="flagship-card__name">{t(`projects.flagships.${key}.name`)}</h3>
                <p className="flagship-card__subtitle">{t(`projects.flagships.${key}.subtitle`)}</p>
                <p className="flagship-card__desc">{t(`projects.flagships.${key}.desc`)}</p>
                <ul className="flagship-card__features">
                  {Array.isArray(features) &&
                    features.map((f) => <li key={f}>{f}</li>)}
                </ul>
              </article>
            );
          })}
        </div>

        <div className="projects__grid projects__grid--secondary">
          {PRODUCTS.map((key) => (
            <article key={key} className="product-card">
              <span className="product-card__tag">{t(`projects.products.${key}.tag`)}</span>
              <h3 className="product-card__name">{t(`projects.products.${key}.name`)}</h3>
              <p className="product-card__desc">{t(`projects.products.${key}.desc`)}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
